<ng-container *ngIf="readyUser">
  <ng-container>
    <app-table [columns]="headerTableUsers" [dataSource]="userList" [hasButton]="true"
      [actionsTemplate]="actionsButtonsUsers" (commentsAdminPanelUserClick)="commentsAdminPanelUserClick($event)"></app-table>

    <ng-template #actionsButtonsUsers let-uid="uid">
      <ng-container *ngFor="let user of (userList | filter : uid : 'uid'); trackBy: trackByIndex">
        <li (click)="ChangeUserStatus(user)">
          <a class="optionMenu">
            <mat-icon>
              {{user.isActivated ? "close" : "done"}}</mat-icon>
            {{user.isActivated ? "Desactivar" : "Activar"}}
          </a>
        </li>
        <!--  <li (click)="openSuscriptionDialog(uid)">
          <a>
            <mat-icon>credit_card</mat-icon> Suscripción
          </a>
        </li> -->
        <li (click)="ChangeConsultant(user)">
          <a class="optionMenu">
            <mat-icon>{{user.isConsultant ? "close" : "work"}}</mat-icon> Asesoría
          </a>
        </li>
        <li (click)="assignAdvisor(uid)">
          <a class="optionMenu">
            <mat-icon>work</mat-icon> Partner
          </a>
        </li>
      </ng-container>
    </ng-template>
  </ng-container>
</ng-container>

<ng-container *ngIf="!readyUser">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
